.InputWithIcon-inputWrapper {
  position: relative;
  border: 1px solid var(--gray_light1);
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  align-items: center;

  .input {
    border: none;
    padding: 8px;
    width: 100%;
    color: var(--gray_dark2);
  }

  .iconWrapper {
    height: 38px;
    align-self: center;
    border-right: 0;
    padding-left: 8px;
    display: flex;

    .suggestionIcon {
      height: 40%;
      align-self: center;
      justify-self: center;
    }
  }

  &:focus-within {
    border-color: var(--color_primary_500);
  }
}